import { Box, Button, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import useStyles from "./HelperBotWorkingStyles";

import { useNavigate } from "react-router-dom";
import helperImg from "../../assets/imgs/slot/helperbot.png";

interface HelperBotWorkingPopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const HelperBotWorkingPopup: React.FC<HelperBotWorkingPopupProps> = ({
  openModal,
  setOpenModal,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleMangeHelperBot = () => {
    navigate("/helper");
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={helperImg} className={classes.logoImg} />
          <Box className={classes.titleText}>Your bot is working!</Box>

          <Box className={classes.description}>
            A fully automated robot is tirelessly working without fatigue or
            complaints.
          </Box>

          <Button
            variant="contained"
            className={classes.confirmBut}
            onClick={handleMangeHelperBot}
          >
            Manage helper bots
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default HelperBotWorkingPopup;
